import React from "react";
import { Link } from "../lib/Link";
import { callable } from "../common/userAgent"
import { openContact, getPhoneNumber, openContactSelector } from "../common/callUtil"


export const footer = (type) => {
  const currentYear = new Date().getFullYear();
  const renewalFooterHtml = `
<div class="footer r_footer">
  <div class="content">
      <div class="r_first">
          <div class="r_col">
              <div class="title">物件を探す</div>
              <a to="/list/" href="/list/">エリアから探す</a>
          </div>
          <div class="r_col">
              <div class="title">ご利用ガイド</div>
                  <a to="/flow" href="/flow">ご契約の流れ</a>
                  <a to="https://faq.hello-storage.com/" href="https://faq.hello-storage.com/">よくある質問</a>
                  <a to="/flow/#f1_3" href="/flow/#f1_3">お支払いについて</a>
                  <a to="/flow/#f1_4" href="/flow/#f1_4">ご契約前の注意事項</a>
                  <a to="/voice2/" href="/voice2/">お客様の声 / 利用事例</a>
          </div>
          <div class="r_col">
              <div class="title">Hello Storageのサービス</div>
                  <a to="/about/" href="/about/">ハローストレージとは</a>
                  <a to="/lineup/" href="/lineup/">商品ラインナップ</a>
                  <a to="/service/" href="/service/">オプションサービス</a>
          </div>
          <div class="r_col">
              <div class="title">運営会社</div>
              <a href="https://www.arealink.co.jp/" target="_blank">エリアリンク（株）公式HP</a>
              <a href="https://www.fudousan-100.com/" target="_blank">土地を活用したい</a>
          </div>
      </div>
      <div class="second">
          <a to="/corporate/" href="/corporate/">会社概要</a>
          <a to="/privacy/" href="/privacy/">個人情報の取扱いについて</a>
          <a to="/policy/" href="/policy/">このサイトについて</a>
          <a to="/agreement/" href="/agreement/">規約</a>
          <a to="/asct/" href="/asct/">特商法に基づく表記</a>
          <a to="/sitemap/" href="/sitemap/">サイトマップ</a>
          <a href="/map.html" target="_blank">アクセス</a>
          <a data-target="modal1" class="modal_open">お問い合わせ</a>
      </div>
  </div>
  <div class="copyright">© 1976, 2018 SANRIO CO., LTD. APPROVAL No. G591512  <br class="br-sp">© `+currentYear+` Arealink.co.,ltd. All Rights Reserved.</div>
</div>
  `;
  return (
    <div dangerouslySetInnerHTML={{__html: renewalFooterHtml}}></div>
  );
};



// WEBPACK FOOTER //
// ./common/footer.jsx